import { useViewModel } from "mvvm/View";
import { FeedbackViewModel } from "../ViewModels/FeedbackViewModel";
import { Popover } from "antd";
import { ParentWrapper } from "styles/global";
import TextArea from "antd/es/input/TextArea";
import ThumbsUpSolidIcon from "components/icons/actions/ThumbsUpSolidIcon";
import ThumbsDownSolidIcon from "components/icons/actions/ThumbsDownSolidIcon";
import ThumbsUpIcon from "components/icons/actions/ThumbsUpIcon";
import ThumbsDownIcon from "components/icons/actions/ThumbsDownIcon";
import { useState } from "react";
import { useDarkMode, useThemeColors, useIsReadOnly } from "redux/hooks";
import { ConditionalTooltip } from "./ConditionalTooltip";


export function FeedbackView(props: { model: FeedbackViewModel}) {

    const vm = useViewModel(props.model);
    const darkMode = useDarkMode();
    const themeColors = useThemeColors();
    const isReadOnly = useIsReadOnly();
    const [isHovered, setIsHovered] = useState(false);
    const [isPressed, setIsPressed] = useState(false);

    return (
        <Popover onOpenChange={open => { if (isReadOnly) return; vm.isOpen = open; }} open={isReadOnly ? false : vm.isOpen} content={
            <ParentWrapper>
                <div className="flex-column text-content" style={{ color: themeColors.textColor }}>
                    <div style={{ color: themeColors.textColor }}>QueryStream uses your feedback to improve the quality of its responses.</div>
                    <TextArea rows={3}
                        className="text-content"
                        placeholder={vm.commentPlaceholder}
                        value={vm.comment}
                        disabled={vm.isSaving}
                        onChange={e => vm.comment = e.target.value}
                        style={{
                            resize: "none",
                            fontSize: "1rem",
                            marginTop: "0.25em",
                            backgroundColor: darkMode ? themeColors.backgroundColorSecondary : undefined,
                            color: themeColors.textColor,
                            borderColor: themeColors.borderColorSecondary
                        }} />
                    <div className="flex-row" style={{ margin: "0.5em 0"}}>
                        <div className="flex-1"></div>
                        <button className="small-secondary-btn" style={{margin: "0 0.5em"}} disabled={vm.isSaving} onClick={()=>vm.isOpen = false}>Cancel</button>
                        {vm.canDelete && <button className="small-secondary-btn" style={{margin: "0 0.5em"}} disabled={vm.isSaving} onClick={()=>vm.delete()}>Delete Feedback</button>}
                        <button className="small-primary-btn" style={{margin: "0"}} disabled={!vm.canSubmit} onClick={()=>vm.submit()}>
                            {vm.isPositive ? <ThumbsUpSolidIcon color="white" /> : <ThumbsDownSolidIcon color="white" />}
                            <span style={{marginLeft: "0.5em"}}>{vm.submitCaption}</span>
                        </button>
                    </div>
                </div>
            </ParentWrapper>
        } trigger="click" placement="top" overlayInnerStyle={{
            width: "50em",
            padding: "0.5em",
            backgroundColor: themeColors.backgroundColorSecondary,
            border: `1px solid ${themeColors.borderColor}`,
            color: themeColors.textColor
        }} >
            <div style={{ display: "inline-block" }}>
                <ConditionalTooltip title={vm.buttonTooltip}>
                    <button
                        onClick={() => {
                            if (isReadOnly) return;
                            setIsPressed(true);
                            setTimeout(() => setIsPressed(false), 200);
                        }}
                        disabled={isReadOnly}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: isReadOnly ? "not-allowed" : "pointer",
                            fontSize: "20px",
                            color: (isHovered || vm.isOpen)
                                ? (darkMode ? themeColors.textColor : "#000000")
                                : (darkMode ? "#888888" : "#AFAFAF"),
                            display: "flex",
                            alignItems: "center",
                            padding: "0",
                            transition: "color 0.2s, transform 0.1s",
                            transform: isPressed ? "scale(0.85)" : "scale(1)"
                        }}
                    >
                        {vm.isActive
                            ? vm.isPositive ? <ThumbsUpSolidIcon scale={1.25} color={(isHovered || vm.isOpen) ? (darkMode ? themeColors.textColor : "#000000") : (darkMode ? "#888888" : "#AFAFAF")} /> : <ThumbsDownSolidIcon scale={1.25} color={(isHovered || vm.isOpen) ? (darkMode ? themeColors.textColor : "#000000") : (darkMode ? "#888888" : "#AFAFAF")} />
                            : vm.isPositive ? <ThumbsUpIcon scale={1.25} color={(isHovered || vm.isOpen) ? (darkMode ? themeColors.textColor : "#000000") : (darkMode ? "#888888" : "#AFAFAF")} /> : <ThumbsDownIcon scale={1.25} color={(isHovered || vm.isOpen) ? (darkMode ? themeColors.textColor : "#000000") : (darkMode ? "#888888" : "#AFAFAF")} />
                        }
                    </button>
                </ConditionalTooltip>
            </div>
        </Popover>
    );
}